import { observer } from 'mobx-react';
import FontBody1 from '../../../../../../components/fonts/font-body1/font-body1';
import FontHeading4 from '../../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import { BUTTON_VARIANTS } from '../../../../../../components/inputs/button-variants';
import { Button } from '../../../../../../components/inputs/button/button';

interface IIntegrationProps {
    isShowRegister: boolean
}

const RefundidCredentials: React.FC<IIntegrationProps> = observer(({ isShowRegister }) => {
    return (
        <>
            {isShowRegister &&
                <div className='integration-register'>
                    <FontHeading4 variant={[FONT_VARIANT.BOLD]}>No active account found</FontHeading4>
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>Please register and then try to connect again</FontBody1>
                    <Button
                        text={'REGISTER'}
                        variant={BUTTON_VARIANTS.Primary}
                        onClick={() => window.open('https://refundid.com/im-a-business', '', 'width=800,height=600,resizeable,scrollbars')}
                    />
                </div>}
        </>
    )
});

export default RefundidCredentials;
